import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { faLinkSlash } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from 'js/components';

/**
 * Shown in place of the Jira reports when the connector can't load data.
 * error: the failed request's error; the API sets `code` when it knows the cause.
 */
function ConnectorErrorCard({ error }) {
  const isBlocked = error?.response?.data?.code === 'connector_blocked';

  return (
    <Card>
      <CardBody>
        <div className="media text-muted mt-4 mb-4">
          <Icon icon={faLinkSlash} size="4x" className="mr-3" fixedWidth />
          <div className="media-body">
            {isBlocked ? (
              <>
                <p>Jira is blocking this connector.</p>
                <p>
                  Jira refused our requests for this team's data. This usually
                  happens when your Jira site restricts access with an IP
                  allowlist or the connector's account loses permission. Ask
                  your Jira admin to allow access for Waypointr, then reload
                  this page.
                </p>
              </>
            ) : (
              <>
                <p>This Jira connector isn't working.</p>
                <p>
                  We couldn't load this team's Jira reports. Check the
                  connector's configuration, then reload this page.
                </p>
              </>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default ConnectorErrorCard;
